import { UserHeaderComponent } from "./user-header.component";
export const UserHeaderModule = angular
    .module('userHeader', [])
    .component(UserHeaderComponent.selector, UserHeaderComponent.component)
    .name;
//# sourceMappingURL=user-header.module.js.map